import React from "react";

import './style.scss';
import {getThemeClasses} from "@common-helpers/get-theme-classes";

export const Footer = ({
   children, theme
}) =>
{
    return (
        <div className={getThemeClasses({baseClass: 'footer', theme})}>
            <div className={'footer__inner'}>
                {children}
            </div>
        </div>
    )
}